module.exports = __webpack_public_path__ + "img/kh1.80a6bfaa.png";